import { Component, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { UpdateAddressService } from 'src/app/shared/components/add-address/update-address.service';
import { MessageConstants } from 'src/app/shared/entity/constants';
import { ErrorMessage, ErrorType } from 'src/app/shared/entity/error.const';
import { CommonService } from 'src/app/shared/services/common/common.service';
import { DataAccessService } from 'src/app/shared/services/data-access/data-access.service';
import { DataRepositoryService } from 'src/app/shared/services/data-repository/data-repository.service';
import { TaskMovementService } from 'src/app/shared/services/operations/task-movement.service';
import { TaskInfoService } from 'src/app/shared/services/task-info/task-info.service';
import { TBTabName } from 'src/app/shared/models/core';
import { TaskBankFilterComponent } from '../task-bank/task-bank-filter/task-bank-filter.component';
import { TaskBankFilterStateService } from 'src/app/shared/services/task-bank-filter/task-bank-filter-state.service';

@Component({
    selector: "app-task-movement",
    templateUrl: "./task-movement.component.html",
    styleUrls: ['./task-movement.component.scss'],
    standalone: false
})
export class TaskMovementComponent {
  @ViewChild('taskBankFilter') taskBankFilter: TaskBankFilterComponent;

  tabName = TBTabName;
  selectedTab: string;
  showConsequencesDialog = false;
  splitItems = [
    {
      label: 'Preview',
      command: () => {
        this.openConseuqnceDialog();
      }
    }]
  constructor(
    public taskInfoService: TaskInfoService,
    public dataAccessService: DataAccessService,
    public taskMovementService: TaskMovementService,
    public updateAddressService: UpdateAddressService,
    private messageService: MessageService,
    public dataRepositoryService: DataRepositoryService,
    private commonService: CommonService,
    private readonly taskBankFilterStateService: TaskBankFilterStateService
  ) {
    this.selectedTab = this.taskInfoService.activeIndex.label;
    this.taskMovementService.taskMovementSuccess.subscribe((res) => {
      if (res !== null) {
        this.showToasterMessage(res);
      }
    });

    this.updateAddressService.updateAddressSuccess.subscribe((updateRes) => {
      if (updateRes !== null) {
        const response: {
          success: boolean;
          status: number | null;
          message: string | null;
        } = {
          success: updateRes?.status ? false : updateRes,
          status: updateRes?.status,
          message:
            !updateRes?.status && !updateRes
              ? ErrorMessage.ADDRESSUPDATEDFAIL
              : ErrorMessage.ADDRESSUPDATEDSUCCESS,
        };
        this.showToasterMessage(response);
      }
    });
  }

  openConseuqnceDialog() {
    this.showConsequencesDialog = true;
  }
  /**
   * To show toaster in the UI
   * for success and failure
   * @param response
   * @param type
   */
  showToasterMessage(response: {
    success: boolean;
    message: string | null;
  }) {
    if (response?.success) {
      this.messageService.add({
        severity: ErrorType.SUCCESS,
        closable: false,
        summary: "",
        detail: response?.message ?? "",
      });
    }
    if(!response?.success) {
      this.messageService.add({
        severity: ErrorType.ERROR,
        closable: false,
        summary: "",
        detail: response?.message ?? "",
      });
    }
  }



  /**
   * confirmPullback() call the method when we are clicking on pullback button which is on for plannedPBM
   * moving tasks to Unplannedpickup from plannedPBM before that taking confirmation from user.
   */
  confirmPullback() {
    this.commonService.showConfirmationAlert(
      MessageConstants.PULLBACKCONFIRMATION,
      MessageConstants.HEADER,
      () => {
        this.taskMovementService.onSubmitTaskMovement();
      },
      () => {
        this.messageService.add({
          severity: ErrorType.ERROR,
          closable: false,
          summary: "",
          detail: ErrorMessage.REJECT,
        });
      }
    );
  }

  /**
   * Handle Update Success Response;
   * @param $event Boolean value
   */

  handleUpdateStateSuccess($event: boolean) {
    this.taskMovementService.resetTaskMovement();
    this.taskMovementService.isTaskMovementDone = true;
    this.taskMovementService.updateWithDeltaPostTaskMovement();
  }

  get hasActiveTaskBankFilter(): boolean {
    const state = this.taskBankFilterStateService.taskBankFilterState();
    const activeTabLabel = this.taskInfoService.activeIndex?.label ?? '';
    return (
      state.tabLabel === activeTabLabel &&
      Boolean(state.serviceCodeKey || state.eventKey)
    );
  }
}
